import { useEffect, useState } from "react";

import { Notifications } from "@mui/icons-material";
import { Badge, IconButton, Tooltip, Zoom } from "@mui/material";

import { NotificationModal } from "components/Notifcation/components/NotificationModal";

import { useDisclosure } from "../../../hooks";

export function NotificationsNavButton() {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [unreadNotificationAmount, setUnreadNotificationAmount] =
    useState<number>(0);

  useEffect(() => {
    const newTitle =
      unreadNotificationAmount > 0
        ? `Evotrux (${unreadNotificationAmount})`
        : "Evotrux";
    if (document.title !== newTitle) {
      document.title = newTitle;
    }
  }, [unreadNotificationAmount]);

  return (
    <>
      <Tooltip
        title="Notifications"
        placement="right"
        TransitionComponent={Zoom}
      >
        <IconButton color="inherit" onClick={onOpen}>
          {unreadNotificationAmount > 0 ? (
            <Badge
              color="primary"
              badgeContent={`${unreadNotificationAmount}`}
              max={99}
            >
              <Notifications fontSize="large" />
            </Badge>
          ) : (
            <Notifications fontSize="large" />
          )}
        </IconButton>
      </Tooltip>
      <NotificationModal
        open={isOpen}
        onClose={onClose}
        onUnreadNotificationAmountChanged={setUnreadNotificationAmount}
      />
    </>
  );
}
